import React from 'react';
import { ScrollView, View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { WcHistory } from '@/components/competition/WcHistory';
import { BackHeader } from '@/components/ui/BackHeader';
import { EmptyState } from '@/components/ui/EmptyState';
import { ErrorState } from '@/components/ui/ErrorState';
import { Screen } from '@/components/ui/Screen';
import { Skeleton } from '@/components/ui/Skeleton';
import { useCompetitionHistory } from '@/features/competition/hooks';

/**
 * Standalone World Cup History screen — every past final and its champion.
 * Reuses the {@link WcHistory} card (which self-hides when empty), wrapping it
 * with the screen-level loading / error / empty states so a direct visit from
 * the home Discover rail never shows a blank page.
 */
export default function HistoryScreen() {
  const { t } = useTranslation();
  const { data, isPending, isError, error, refetch } = useCompetitionHistory();
  const finals = data ?? [];

  return (
    <Screen>
      <BackHeader title={t('history.title')} />
      {isPending ? (
        <View className="gap-3 px-4 pt-2">
          {[0, 1, 2].map((index) => (
            <Skeleton key={index} className="h-44 w-full" />
          ))}
        </View>
      ) : isError ? (
        <ErrorState error={error} onRetry={() => refetch()} />
      ) : finals.length === 0 ? (
        <EmptyState
          icon="trophy-outline"
          title={t('history.emptyTitle')}
          body={t('history.emptyBody')}
        />
      ) : (
        <ScrollView contentContainerStyle={{ paddingBottom: 36, paddingTop: 8 }}>
          <WcHistory />
        </ScrollView>
      )}
    </Screen>
  );
}
